import { FieldErrors } from 'react-hook-form';
import { SourceThresholdInternal } from '../../../../../../../data-access/gql-types/graphql';
import { MeterConfigurationBody } from '../types';

export const sourceThresholdUnit = {
  [SourceThresholdInternal.ActivePower]: 'kW',
  [SourceThresholdInternal.ApparentPower]: 'VA',
  [SourceThresholdInternal.BalancedPower]: 'kW',
  [SourceThresholdInternal.Current]: 'A',
  [SourceThresholdInternal.Frequency]: 'Hz',
  [SourceThresholdInternal.PhaseAngle]: '°',
  [SourceThresholdInternal.PowerFactor]: '',
  [SourceThresholdInternal.ReactivePower]: 'var',
  [SourceThresholdInternal.Unknown]: '',
  [SourceThresholdInternal.Voltage]: 'V',
};

export const configurationInitialValues = {
  minValue: 0,
  maxValue: 0,
  hysteresis: 0,
  deadTimeInMs: 0,
  minPrice: '0',
  maxPrice: '0',
  cheapestPeriods: '1',
  startAt: '00:00:00',
  endAt: '00:00:00',
  minPriceChecked: false,
  maxPriceChecked: false,
  cheapestPeriodsChecked: false,
};

export const getErrorIndexes = (errors: FieldErrors<MeterConfigurationBody>) => {
  const rulesErrors = errors.rules;

  return rulesErrors
    ? Object.keys(rulesErrors).reduce((acc, key) => {
        acc[Number(key)] = true;
        return acc;
      }, {} as Record<number, true>)
    : {};
};
